import { render, staticRenderFns } from "./GBAdditionalInfo.vue?vue&type=template&id=4831f6f4&"
import script from "./GBAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./GBAdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./GBAdditionalInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports